import { Check, X } from "lucide-react";
import { Card } from "@/components/ui/card";

const PaidAdsComparison = () => {
  const metrics = [
    {
      metric: "Cost Per Lead",
      industry: "£85-120",
      vgp: "£45-65",
      improvement: "45% Lower",
      better: true
    },
    {
      metric: "Lead Response Time",
      industry: "24-48 hours",
      vgp: "< 60 seconds",
      improvement: "98% Faster",
      better: true
    },
    {
      metric: "Lead-to-Customer Rate",
      industry: "8-12%",
      vgp: "18-25%",
      improvement: "2X Higher",
      better: true
    },
    {
      metric: "Average ROAS",
      industry: "1.5X-2X",
      vgp: "2.4X-3.2X",
      improvement: "60% Better",
      better: true
    },
    {
      metric: "Campaign Optimization",
      industry: "Weekly",
      vgp: "Daily",
      improvement: "7X More Frequent",
      better: true
    },
    {
      metric: "Lead Qualification",
      industry: "Manual",
      vgp: "Automated",
      improvement: "100% Automated",
      better: true
    },
    {
      metric: "SMS Follow-up",
      industry: "Rarely",
      vgp: "Always",
      improvement: "85% Response Rate",
      better: true
    },
    {
      metric: "CRM Integration",
      industry: "Basic",
      vgp: "Full Automation",
      improvement: "Seamless Integration",
      better: true
    }
  ];

  return (
    <div className="max-w-6xl mx-auto">
      <Card className="overflow-hidden">
        {/* Desktop Table View */}
        <div className="hidden lg:block">
          {/* Table Header */}
          <div className="grid grid-cols-4 bg-muted/50 border-b border-border">
            <div className="p-6 font-semibold text-foreground">
              Performance Metric
            </div>
            <div className="p-6 text-center font-semibold text-muted-foreground border-l border-border">
              Industry Average
            </div>
            <div className="p-6 text-center font-semibold text-primary border-l border-border">
              VGP Performance
            </div>
            <div className="p-6 text-center font-semibold text-foreground border-l border-border">
              Improvement
            </div>
          </div>

          {/* Table Body */}
          <div className="divide-y divide-border">
            {metrics.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-4 hover:bg-muted/30 transition-colors"
              >
                {/* Metric Name */}
                <div className="p-6 font-medium text-foreground flex items-center">
                  {item.metric}
                </div>

                {/* Industry Average */}
                <div className="p-6 text-center border-l border-border flex items-center justify-center">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-muted flex items-center justify-center">
                      <X className="w-4 h-4 text-muted-foreground" />
                    </div>
                    <span className="text-muted-foreground">{item.industry}</span>
                  </div>
                </div>

                {/* VGP Performance */}
                <div className="p-6 text-center border-l border-border flex items-center justify-center bg-primary/5">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                    <span className="font-semibold text-primary">{item.vgp}</span>
                  </div>
                </div>

                {/* Improvement */}
                <div className="p-6 text-center border-l border-border flex items-center justify-center">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-semibold">
                    <Check className="w-4 h-4" />
                    {item.improvement}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile View */}
        <div className="lg:hidden divide-y divide-border">
          {metrics.map((item, index) => (
            <div key={index} className="p-6 space-y-4">
              <h4 className="font-semibold text-foreground text-lg">
                {item.metric}
              </h4>
              
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">Industry Average:</span>
                  <span className="text-muted-foreground">{item.industry}</span>
                </div>
                
                <div className="flex items-center justify-between bg-primary/5 -mx-6 px-6 py-3">
                  <span className="text-sm font-semibold text-primary">VGP Performance:</span>
                  <span className="font-semibold text-primary">{item.vgp}</span>
                </div>
                
                <div className="flex items-center justify-between">
                  <span className="text-sm text-foreground">Improvement:</span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-semibold">
                    <Check className="w-4 h-4" />
                    {item.improvement}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* Note */}
      <div className="mt-6 text-center">
        <p className="text-sm text-muted-foreground">
          * Performance data based on 12-month averages across all VGP client campaigns vs. industry benchmarks from major advertising platforms.
        </p>
      </div>
    </div>
  );
};

export default PaidAdsComparison;
